const state = {
  warningData: {},
  drawAllData: {},
  showW: false,
  users: {
    userId: "",
    userName: ""
  },
  botId: "",
  robotSettings: {
    robotAvatar: "",
    robotName: "",
    welcomeMessage: ""
  },
  drillHierarchy: [
    {
      keyId: "item",
      children: [
        {
          keyId: "item1"
        }
      ]
    }
  ],
  warningCount: 0,
  reportCount: 0, // 简报推送
  collectQueryData: null,
  bubbleLoading: false,
  guidanceModal: false,
  helpVisible: false,
  authUserVisible: false,
  visibleHelpType: -1,
  stateGridVoiceToken: {
    accessToken: "",
    expireIn: 0,
    scope: ""
  },
  // pc右侧弹窗-记录当前是哪个按钮触发的弹窗
  moreAbilityPath: "",
  fullScreen: false, //是否全屏,
  dispatch: "SmartQ",
  // 提问方式介绍，记住我知道了
  questionKnow: false,
  isMobile: true,
  isShowBanner: false, // 是否展示轮播banner
  waterConfig: {}, // 水印信息
  botDifySessionId: "",
  conversationId: "",
  messageId: ""
};
const mutations = {
  // sql res_id  req_id
  setBotId(state, id) {
    state.botId = id;
  },
  setDrawAllDataItem(state, item) {
    state.drawAllData[item.s_k] = item.s_v;
  },
  setWarningDataItem(state, item) {
    state.warningData = item;
  },
  setShowW(state, bool) {
    state.showW = bool;
  },
  setUsers(state, obj) {
    state.users = obj;
  },
  setRobotSettings(state, obj) {
    state.robotSettings = obj;
  },
  setStateGridVoiceToken(state, obj) {
    state.stateGridVoiceToken = obj;
  },
  setDrillHierarchy(state, obj) {
    let data = JSON.parse(JSON.stringify(state.drillHierarchy));
    let res = [];
    const flatTree = arr => {
      arr.forEach(el => {
        res.push(el);
        el.children && el.children.length ? flatTree(el.children) : "";
      });
    };
    flatTree(data);
    let num = 0;
    let totalL = res.length;
    let flag = false;
    const saveObj = array => {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        num++;
        if (element.keyId === obj.parentId && num <= totalL) {
          if (!element.children) {
            element.children = [];
          }
          element.children.push({ keyId: obj.childId });
          return;
        } else if (num === totalL) {
          flag = true;
          return;
        }
        if (element.children && element.children.length) {
          saveObj(element.children);
        }
      }
    };
    saveObj(data);
    if (flag) {
      data.push({
        keyId: obj.parentId,
        children: [{ keyId: obj.childId }]
      });
    }
    state.drillHierarchy = data;
  },
  setWarningCount(state, count) {
    state.warningCount = count;
  },
  setReportCount(state, count) {
    state.reportCount = count;
  },
  setCollectQueryData(state, data) {
    state.collectQueryData = data;
  },
  startBubbleLoading(state) {
    state.bubbleLoading = true;
  },
  resetBubbleLoading(state) {
    state.bubbleLoading = false;
  },
  setHelpVisible(state, visible) {
    state.helpVisible = visible;
  },
  setAuthUserVisible(state, visible) {
    state.authUserVisible = visible;
  },
  setGuidanceModal(state, visible) {
    state.guidanceModal = visible;
  },
  setVisibleHelpType(state, type) {
    state.visibleHelpType = type;
  },
  // 打开右侧按钮时触发修改
  setMoreAbilityPath(state, type) {
    state.moreAbilityPath = type;
  },
  setDispatch(state, val) {
    state.dispatch = val;
  },
  setQuestionKnow(state, val) {
    state.questionKnow = val;
  },
  setIsMobile(state, val) {
    state.isMobile = val;
  },
  setIsShowBanner(state, val) {
    state.isShowBanner = val;
  },
  setFullScreen(state, val) {
    state.fullScreen = val;
  },
  setWaterConfig(state, val) {
    state.waterConfig = val;
  },
  setConversationId(state, val) {
    state.conversationId = val;
  },
  setMessageId(state, val) {
    state.messageId = val;
  },
  setBotDifySessionId(state, val) {
    state.botDifySessionId = val;
  }
};
const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  modules: {}
};
